import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { AxiosError } from 'axios';
import { ErrorResponse } from '@hud/portal-dtos/src/lib/webapp-common.dto';
import {
  LiveCodeRequest,
  LiveCodeResponse,
} from '@hud/portal-dtos/webapp-function.dto';
import { PORTAL_BASE } from '../consts';

export const LIVE_CODE_ID = 'live-code';

export default function useLiveCodeQuery(
  params: Omit<LiveCodeRequest, 'serviceId'> & { serviceId: number | null },
) {
  const { client, isReady } = useClient();
  return useQuery<LiveCodeResponse, AxiosError<ErrorResponse>>({
    queryKey: [LIVE_CODE_ID, params],
    queryFn: async () => {
      const response = await client.get<LiveCodeResponse>(
        `${PORTAL_BASE}/live-code`,
        {
          params,
        },
      );
      return LiveCodeResponse.parse(response.data);
    },
    enabled: Number.isInteger(params.serviceId) && isReady,
    retry: (failureCount, error) => {
      if (
        error?.response?.status &&
        error.response.status > 401 &&
        error.response.status < 500
      ) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
